import { render, staticRenderFns } from "./four_pictures.vue?vue&type=template&id=5e86c150&scoped=true"
import script from "./four_pictures.vue?vue&type=script&lang=js"
export * from "./four_pictures.vue?vue&type=script&lang=js"
import style0 from "./four_pictures.vue?vue&type=style&index=0&id=5e86c150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86c150",
  null
  
)

export default component.exports